import styled from 'styled-components'

export const AlarmsTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 20px 0;
    @media (min-width: 992px) {
        width: 750px;
        width: 970px;
    }
    @media (min-width: 1600px) {
        width: 1170px;
    }

    .text-title {
        font-weight: 600;
        font-size: 14px;
    }

    .text-body {
        font-weight: 400;
        font-size: 14px;
    }
`
